import React, { useState } from 'react';
import {
    Box,
    Button,
    FileInput,
    Form,
    FormField,
    Header,
    Heading,
    Paragraph,
    Select,
    SelectMultiple,
    Spinner,
    Text,
    TextArea,
    TextInput,
} from 'grommet';
import http from '../utils/http';
import UploadDataTable from './UploadDataTable';

const Visibility = () => {
    const [choice, setChoice] = React.useState('Private');
    return (
        <Select
            options={['Public', 'Private', 'Unlisted']}
            onChange={({ option }) => setChoice(option)}
            placeholder="Visibility"
        />
    )
}

const Title = () => {
    return (
        <Form>
            <FormField name="title" label="Title" htmlFor="title">
                <TextInput
                    name="title"
                    id="title"
                    placeholder=''
                    type='title'
                />
            </FormField>
        </Form>
    );
}

const Type = () => {
    const [ type, setType ] = React.useState('');
    return (
        <SelectMultiple
            options={['Tweet', 'Reels', 'Story', 'Video', 'Image', 'Blog', 'Thread', 'Post', 'Podcast', 'Track', 'Stream', 'Feed', 'Shorts']}
            onChange={({ option }) => setType(option)}
            placeholder="Social Media Platform"
        />
    )
}

const Description = () => {
    const [description, setDescription] = React.useState('');
    return (
        <Form>
            <FormField name='description' label='Description' htmlFor='description'>
                <TextArea
                    placeholder=''
                    value={description}
                    onChange={ event => setDescription(event.target.value) }
                />
            </FormField>
        </Form>
    )
}

const UploadView = ({ user }) => {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [showUploadStatus, setShowUploadStatus] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [showZeroFilesUploaded, setShowZeroFilesUploaded] = useState(true);
    const [dataTableArray, setDataTableArray] = useState([{}])

    return (
        <Box gap='medium' alignSelf='center' pad={{ top: 'large' }}>
            <Header
                direction="column"
                align='start'
                gap='xxsmall'
                pad={{ horizontal: 'xsmall' }}
            >
                <Heading level={2} margin="none">
                    Upload
                </Heading>
                <Text>
                    Secure and verify ownership of digital media files.
                </Text>
            </Header>
            <FileInput
                messages={{
                    dropPrompt: 'Drag and drop',
                    browse: files.length > 0 ? 'Replace file' : 'Select file'
                }}
                onChange={(event, { files }) => {
                    setFiles(files)
                    setShowUploadStatus(false)
                    setShowZeroFilesUploaded(false);
                }}
            >
            </FileInput>
            <Visibility />
            <Title />
            <Type />
            <Description />
            <Button
                primary
                label="Submit"
                onClick={ async () => {
                    setUploading(true);
                    setShowUploadStatus(false);
                    setDataTableArray([]);
                    if (!files.length) {
                        setUploading(false);
                        setShowUploadStatus(true);
                        setShowZeroFilesUploaded(true);
                        setUploadStatus('File upload length must be greater than 0')
                        return;
                    }
                    const promises = files.map(async file => {
                        try {
                            const res = await http.postFile(file, user);
                            console.log(res);
                            return res;
                        } catch (err) {
                            console.error(err);
                            console.error(err.message);
                            setUploadStatus(err.message);
                            if (err.filename) {
                                return err;
                            }
                            return {
                                filename: file.name,
                                status: false,
                                code: 'ERROR',
                                message: err.message
                            }
                        }
                    })
                    const newDataTableArray = await Promise.all(promises);
                    console.log(newDataTableArray);
                    setDataTableArray(
                        newDataTableArray
                    )
                    setShowUploadStatus(true);
                    setUploading(false);
                }}
            ></Button>
            { uploading && <Spinner message="Uploading files" alignSelf='center' size="medium"/>}
            { showUploadStatus && (
                <Box>
                    { showZeroFilesUploaded && (
                        <Paragraph style={{color: 'red'}}>{uploadStatus}</Paragraph>
                    )}
                    { files.length > 0 && <UploadDataTable dataTableArray={dataTableArray}/> }
                </Box>
            )}
        </Box>
    )
}

export default UploadView;